/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';

import { SalesProspectingLeadGenerationAutomation } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationAutomation/SalesProspectingLeadGenerationAutomation';
import { SalesProspectingLeadGenerationExport } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationExport/SalesProspectingLeadGenerationExport';
import { SalesProspectingLeadGenerationExtension } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationExtension/SalesProspectingLeadGenerationExtension';
import { SalesProspectingLeadGenerationHero } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationHero/SalesProspectingLeadGenerationHero';
import { SalesProspectingLeadGenerationOutreach } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationOutreach/SalesProspectingLeadGenerationOutreach';
import { SalesProspectingLeadGenerationProblem } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationProblem/SalesProspectingLeadGenerationProblem';
import { SalesProspectingLeadGenerationQuote } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationQuote/SalesProspectingLeadGenerationQuote';
import { SalesProspectingLeadGenerationSignals } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationSignals/SalesProspectingLeadGenerationSignals';
import { SalesProspectingLeadGenerationTaxonomy } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationTaxonomy/SalesProspectingLeadGenerationTaxonomy';
import { SalesProspectingLeadGenerationTerms } from 'landing-pages/sales-prospecting-lead-generation/sections/SalesProspectingLeadGenerationTerms/SalesProspectingLeadGenerationTerms';

import styles from './SalesProspectingLeadGenerationPage.module.scss';

import { getFaqItems } from './SalesProspectingLeadGenerationPage.data';

export const SalesProspectingLeadGenerationPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <SalesProspectingLeadGenerationHero />
      <SalesProspectingLeadGenerationProblem />
      <SalesProspectingLeadGenerationExport />
      <SalesProspectingLeadGenerationTerms />
      <SalesProspectingLeadGenerationTaxonomy />
      <SalesProspectingLeadGenerationOutreach />
      <SalesProspectingLeadGenerationSignals />
      <SalesProspectingLeadGenerationExtension />
      <SalesProspectingLeadGenerationAutomation />
      <SalesProspectingLeadGenerationQuote />
      <Faq className={styles.faq} title={t('What buyers ask before they switch')} data={getFaqItems(t)} />
    </div>
  );
};
